"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyClassListTitle = void 0;
const react_1 = __importDefault(require("react"));
const SearchInput_1 = require("../ui/SearchInput");
exports.AcademyClassListTitle = react_1.default.memo(({ searchOption, setSearchOption, }) => {
    return react_1.default.createElement(SearchInput_1.SearchInput, { defaultValue: searchOption, setSearchOption: setSearchOption });
});
